goog.provide('el8.appshared.dialog.epnSearchPrompt');

goog.require('el8.uiwidget.FormDialog');
goog.require('el8.uiwidget.Form');
goog.require('el8.template.appshared.dialog.epnSearchPrompt');

el8.appshared.dialog.epnSearchPrompt = (function() {

    var searchString = '';

    var that = new el8.uiwidget.FormDialog({
        title: 'Search for Provider Profile',
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.appshared.dialog.epnSearchPrompt.content();
        },
        showXButton: true
    });

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        super_show.call(that);

        if (spec.promptMessage) {
            $('.prompt-message', that.getContentElt()).html(spec.promptMessage);
        } else {
            $('.prompt-message', that.getContentElt()).html('Search for a provider profile in Elation Provider Network');
        }

        searchString = spec.searchString || '';
    };

    that.form = new el8.uiwidget.Form({
        fields: []
    });
    that.form.addButton('submit', 'Search', function() {
      el8.appchart.providers.main.show({searchString: searchString});
      that.hide();
    }, true);
    that.form.addButton('cancel', 'Cancel', function() { that.hide(); }, false);
    that.setForm(that.form);

    return that;

})();
